import API from '../../apiConfig';

export const getCityState = async (pincode) => {
  const response = await API.get('/address/pincode_detail', {
    params: { pincode },
  });
  return response;
};

export const supplierRegister = async (data) => {
  const response = await API.postWithoutToken('supplier/registration', data);
  return response;
};

export const supplierSelfRegister = async (data) => {
  const response = await API.postWithoutToken('/supplier/selfRegistrationRequest', data);
  return response;
};

export const uploadRegistrationDocs = async (data) => {
  const response = await API.postWithoutToken('/supplier/uploadRegistrationDocs', data);
  return response;
};
